import {all, fork} from 'redux-saga/effects';
import {getAccountSaga} from './get-account.saga';
import {verifyEmailAddressSaga} from './verify-email-address.saga';

export function* accountSaga() {
    yield all([fork(getAccountSaga), fork(verifyEmailAddressSaga)]);
}
